// @flow

import EPaymentMode from './EPaymentMode';

const ApiConstants = {
  Platform: {
    IOS: 'IOS',
    ANDROID: 'ANDROID',
    BACK_OFFICE_WEB: 'BACK_OFFICE_WEB',
    PLUGIN_WEB: 'PLUGIN_WEB',
    BOT: 'BOT',
    POS: 'POS',
    KIOSK: 'KIOSK',
    OTHER: 'OTHER',
  },

  Day: {
    MONDAY: 0,
    TUESDAY: 1,
    WEDNESDAY: 2,
    THURSDAY: 3,
    FRIDAY: 4,
    SATURDAY: 5,
    SUNDAY: 6
  },

  // -- Restaurant

  RestaurantFeatures: {
    PAYMENT: 1,

    ORDER: 2,

    BOOKING: 4,

    NEWS: 8,

    REVIEW: 16,
  },

  RestaurantTag: [
    'restaurant.tag.africain',
    'restaurant.tag.algerien',
    'restaurant.tag.allemand',
    'restaurant.tag.americain',
    'restaurant.tag.amerique_latine',
    'restaurant.tag.anglais',
    'restaurant.tag.apero',
    'restaurant.tag.argentin',
    'restaurant.tag.asiatique',
    'restaurant.tag.autrichien',
    'restaurant.tag.bagel',
    'restaurant.tag.bar',
    'restaurant.tag.bbq',
    'restaurant.tag.belge',
    'restaurant.tag.bio',
    'restaurant.tag.boulettes',
    'restaurant.tag.brasserie',
    'restaurant.tag.bresilien',
    'restaurant.tag.brunch_and_petit_dejeuner',
    'restaurant.tag.bubble_tea',
    'restaurant.tag.burger',
    'restaurant.tag.canadien',
    'restaurant.tag.cafétéria',
    'restaurant.tag.casher',
    'restaurant.tag.ceviche',
    'restaurant.tag.chilien',
    'restaurant.tag.chinois',
    'restaurant.tag.cocktail',
    'restaurant.tag.colombien',
    'restaurant.tag.coreen',
    'restaurant.tag.corse',
    'restaurant.tag.creole',
    'restaurant.tag.croque_monsieur',
    'restaurant.tag.cubain',
    'restaurant.tag.cuisine_du_marche',
    'restaurant.tag.dim_sum',
    'restaurant.tag.epice',
    'restaurant.tag.espagnol',
    'restaurant.tag.europe__est',
    'restaurant.tag.fish_and_chips',
    'restaurant.tag.francais',
    'restaurant.tag.frozen_yoghurt',
    'restaurant.tag.fruits_de_mer_crustacés',
    'restaurant.tag.grand_groupe',
    'restaurant.tag.grec',
    'restaurant.tag.halal',
    'restaurant.tag.healthy',
    'restaurant.tag.homard',
    'restaurant.tag.hot_dog',
    'restaurant.tag.indien',
    'restaurant.tag.indonesien',
    'restaurant.tag.iranien',
    'restaurant.tag.italien',
    'restaurant.tag.japonais',
    'restaurant.tag.jus_smoothies',
    'restaurant.tag.laotien',
    'restaurant.tag.libanais',
    'restaurant.tag.marocain',
    'restaurant.tag.mediterranéen',
    'restaurant.tag.mexicain',
    'restaurant.tag.moyen_orient',
    'restaurant.tag.oriental',
    'restaurant.tag.patisserie',
    'restaurant.tag.peruvien',
    'restaurant.tag.pizza',
    'restaurant.tag.polonais',
    'restaurant.tag.portugais',
    'restaurant.tag.rotisserie',
    'restaurant.tag.russe',
    'restaurant.tag.salade',
    'restaurant.tag.sandwich',
    'restaurant.tag.sans_gluten',
    'restaurant.tag.scandinave',
    'restaurant.tag.soupe',
    'restaurant.tag.suisse',
    'restaurant.tag.sushi',
    'restaurant.tag.syrien',
    'restaurant.tag.tapas',
    'restaurant.tag.tarte_salée',
    'restaurant.tag.terroir',
    'restaurant.tag.thailandais',
    'restaurant.tag.tibetain',
    'restaurant.tag.tunisien',
    'restaurant.tag.turc',
    'restaurant.tag.vegan',
    'restaurant.tag.veggie',
    'restaurant.tag.venezuelien',
    'restaurant.tag.vietnamien',
  ],

  RestaurantTheme: {
    DEFAULT_BACKGROUND_COLOR: 0xFFFFFFFF,

    DEFAULT_FONT_COLOR: 0xFF454545,

    DEFAULT_TITLE_BACKGROUND_COLOR: 0xFF232323,

    DEFAULT_TITLE_FONT_COLOR: 0xFFFFFFFF,

    DEFAULT_ACTION_BACKGROUND_COLOR: 0xFF9DC212,

    DEFAULT_ACTION_FONT_COLOR: 0xFFFFFFFF
  },

  // -- Payment
  BankType: {
    MANGOPAY: 'MANGOPAY',
    PAYZEN: 'PAYZEN',
  },

  // keep old way to call.
  // @deprecated
  CreditCardType: EPaymentMode,

  // -- Order
  // Bitfield enum (1, 2, 4, 8, 16, 32, ...)
  OrderPaymentMethodsAllowed: {
    IRL: 1,

    CREDIT_CARD: 2,

    USER_ACCOUNT: 4,

    TRD: 8,
  },

  OrderStatus: {
    CREATED: 'CREATED', // object is created but not yet paid nor sent to the POS
    SENT: 'SENT', // paid (if needed) and successfully sent to the POS
    RECEIVED: 'RECEIVED', // order received and accepted by the restaurant
    //PRODUCING: 'PRODUCING', // order sent to production by the restaurant
    READY: 'READY', // order ready to be picked-up by the user who ordered
    IN_DELIVERY: 'IN_DELIVERY', // order picked-up by the delivery man
    DELIVERED: 'DELIVERED', // order retrieved by the user who ordered
    CANCELED: 'CANCELED', // order manually canceled
    FAILED: 'FAILED', // order failed, probably because the payment failed or we weren't able to send it to the POS
  },

  // -- Review

  Review: {
    REASONS: {
      WAIT_ARRIVAL: 'Attente à l’arrivée',
      SERVICE: 'Service',
      PRODUCT_QUALITY: 'Qualité de la nourriture',
      WAIT_DINNING: 'Attente durant le repas',
      DECORATION: 'Décoration',
      OTHER: 'Autre'
    }
  },

  Image: {
    MAX_SIZE: 1000000,

    RestaurantMenuPdfPicture: {
      RATIO: (960 / 639),
      WIDTH: 960,
      HEIGHT: 639,
      MAX_SIZE: 100000 // unused
    },

    RestaurantLogo: {
      RATIO: (254 / 254),
      WIDTH: 450,
      HEIGHT: 450,
      MAX_SIZE: 100000 // unused
    },

    News: {
      RATIO: (840 / 420),
      WIDTH: 840,
      HEIGHT: 420,
      MAX_SIZE: 10000 // unused
    },

    RestaurantMenu: {
      Product: {
        RATIO: (840 / 420),
        WIDTH: 840,
        HEIGHT: 420,
        MAX_SIZE: 10000 // unused
      },

      Menu: {
        RATIO: (840 / 420),
        WIDTH: 840,
        HEIGHT: 420,
        MAX_SIZE: 10000 // unused
      },

      Category: {
        RATIO: (840 / 840),
        WIDTH: 250,
        HEIGHT: 250,
        MAX_SIZE: 10000 // unused
      },

      ProductOption: {
        RATIO: (840 / 840),
        WIDTH: 250,
        HEIGHT: 250,
        MAX_SIZE: 10000 // unused
      },

      MenuPartCategory: {
        RATIO: (840 / 840),
        WIDTH: 250,
        HEIGHT: 250,
        MAX_SIZE: 10000 // unused 
      }
    },
  },

  Kiosk: {
    Order: {
      BackgroundImage: {
        RATIO: (1280 / 1920),
        WIDTH: 1280,
        HEIGHT: 1920,
        MAX_SIZE: 10000, // unused
      },
      AdvertisingImage: {
        RATIO: (880 / 275),
        WIDTH: 880,
        HEIGHT: 275,
        MAX_SIZE: 10000, // unused
      }
    }
  }
};

export default ApiConstants;



// WEBPACK FOOTER //
// ./sdk/scripts/constants/ApiConstants.js